import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getFulfillmentGroupTracking } from "@redotech/redo-fulfillment-group-common/fulfillment-group-tracking";
import CopyIcon from "@redotech/redo-icons/copy-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";
import * as styles from "./tracking-number-column.module.css";

const catalogEntry = fgColumnEntries.trackingNumber;

export const TrackingNumberColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  width: catalogEntry.defaultWidth,
  renderNormalCell: ({ row }) => {
    const tracking = getFulfillmentGroupTracking(row);
    if (!tracking.length) {
      return null;
    }
    return (
      <Flex align="center" gap="sm" pl="lg">
        {tracking.map(({ trackingNumber, link }) => (
          <Text
            className={link ? styles.link : undefined}
            fontSize="xs"
            key={trackingNumber}
            onClick={link ? () => window.open(link, "_blank") : undefined}
            textColor="secondary"
          >
            {`#${trackingNumber}`}
          </Text>
        ))}
        <RedoButton
          aria-label="Copy"
          IconLeading={CopyIcon}
          onClick={async () => {
            await navigator.clipboard.writeText(
              tracking.map(({ trackingNumber }) => trackingNumber).join(", "),
            );
          }}
          size="xs"
        />
      </Flex>
    );
  },
  alignment: ColumnAlignment.LEFT,
};
